import React, { useState, useEffect } from 'react';
import './Plans.css';
import toast from 'react-hot-toast';


const BPlans = ({product}) => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [form, setForm] = useState({
    id: null,
    plan_name: '',
    plan_type: '',
    pricing: '',
    tagline: '',
    description: '',
  });

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    setLoading(true);

    try {
      const response = await fetch(
          product == 'Salon Software' ?
        'https://api.dectwincam.com/sapi/get-premium-plans'
        :
        'https://api.dectwincam.com/dapi/get-premium-plans'
      );

      if (response.ok) {
        const data = await response.json();
        setPlans(data);
      }
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  };

  // =========================
  // OPEN ADD MODAL
  // =========================
  const openAddModal = () => {
    setForm({
      id: null,
      plan_name: '',
      plan_type: '',
      pricing: '',
      tagline: '',
      description: '',
    });

    setIsEdit(false);
    setShowModal(true);
  };

  // =========================
  // OPEN EDIT MODAL
  // =========================
  const openEditModal = (plan) => {
    setForm(plan);
    setIsEdit(true);
    setShowModal(true);
  };

  // =========================
  // HANDLE CHANGE
  // =========================
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // =========================
  // SUBMIT
  // =========================
const handleSubmit = async () => {
  const toastId = toast.loading(
    isEdit ? 'Updating plan...' : 'Creating plan...'
  );

  try {
    const url = 
    isEdit
      ?           product == 'Salon Software' ?
      `https://api.dectwincam.com/sapi/update-plans/${form.id}`
        :

      `https://api.dectwincam.com/dapi/update-plans/${form.id}`
      :     product == 'Salon Software' ?
      'https://api.dectwincam.com/sapi/add-plans'        :

      'https://api.dectwincam.com/dapi/add-plans';

    const method = isEdit ? 'PUT' : 'POST';

    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(form),
    });

    const data = await response.json();

    if (response.ok) {
      toast.success(
        isEdit ? 'Plan updated successfully' : 'Plan created successfully',
        { id: toastId }
      );

      setShowModal(false);
      fetchPlans();
    } else {
      toast.error(data.message || 'Something went wrong', {
        id: toastId,
      });
    }
  } catch (error) {
    console.error(error);

    toast.error('Server error', {
      id: toastId,
    });
  }
};


  return (
    <section className='containerfluid py-4'>

      {/* HEADER */}
      <div className='d-flex justify-content-between align-items-center'>
        <div>
          <h2 className='plans-title'>Subscription Plans</h2>
          <p className='plans-subtitle'>
            Manage your premium plans
          </p>
        </div>

        <button
          className='btn btn-dark'
          onClick={openAddModal}
        >
          Add New
        </button>
      </div>

      {/* LOADING */}
      {loading ? (
        <div className='text-center py-5'>
          <div className='spinner-border text-primary'></div>
        </div>
      ) : (
        <div className='row g-4 mt-1'>
          {plans.map((plan) => (
            <div className='col-lg-6' key={plan.id}>
              <div className='plan-card'>

                <div className='mb-3'>
                  <h3 className='plan-name'>
                    {plan.plan_name}
                  </h3>
                  <p className='plan-tagline'>
                    {plan.tagline}
                  </p>
                </div>

                <div className='plan-price-wrapper'>
                  <span className='plan-currency'>₹</span>
                  <span className='plan-price'>
                    {plan.pricing} / <span className='fs-4 fw-semibold'>{plan.plan_type} Year</span>
                  </span>
                </div>

                <div className='plan-features'>
                  {plan.description
                    .split('\r\n')
                    .filter(Boolean)
                    .map((f, i) => (
                      <div
                        className='plan-feature-item'
                        key={i}
                      >
                        <i className='fa-solid fa-check'></i>
                        <span>{f.replace('✔', '')}</span>
                      </div>
                    ))}
                </div>

                <button
                  className='plan-btn'
                  onClick={() => openEditModal(plan)}
                >
                  Edit Plan
                </button>

              </div>
            </div>
          ))}
        </div>
      )}

      {/* ================= MODAL ================= */}
      {showModal && (
        <div className='modal-overlay'>
          <div className='modal-box col-md-4 col-10'>

            <h4>
              {isEdit ? 'Edit Plan' : 'Add Plan'}
            </h4>

<label className='fw-semibold mt-3'>Plan Name</label>
            <input
              name='plan_name'
              value={form.plan_name}
              onChange={handleChange}
            />

          <label className='fw-semibold mt-3'>Years</label>
  <input
              name='plan_type'
              type='number'
              placeholder='one_year'
              value={form.plan_type}
              onChange={handleChange}
            />

<label className='fw-semibold mt-3'>Price</label>
            <input
              name='pricing'
              value={form.pricing}
              onChange={handleChange}
            />

       <label className='fw-semibold mt-3'>Tagline</label>
     <input
              name='tagline'
              value={form.tagline}
              onChange={handleChange}
            />

                 <label className='fw-semibold mt-3'>Details</label>
  <textarea
              name='description'
              placeholder='Write here (use ✔ line by line)'
              rows='5'
              value={form.description}
              onChange={handleChange}
            />

            <div className='d-flex justify-content-end gap-2 mt-3'>
              <button
                className='btn btn-secondary'
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>

              <button
                className='btn btn-dark'
                onClick={handleSubmit}
              >
                {isEdit ? 'Update Now' : 'Add Now'}
              </button>
            </div>

          </div>
        </div>
      )}

    </section>
  );
};

export default BPlans;